export class ServiceContainer {
    constructor() {
        this.services = new Map();
    }
    register(key, service) {
        this.services.set(key, service);
    }
    resolve(key) {
        return this.services.get(key);
    }
}
let getServiceContainerCallback = null;
export const registerGetServiceContainerCallback = (callback) => {
    getServiceContainerCallback = callback;
};
export const getServiceContainer = () => {
    if (getServiceContainerCallback) {
        return getServiceContainerCallback();
    }
    return null;
};
